import { toJS } from "mobx";
import AdminStore from "../stores/internal/AdminStore";

export const getAllSites = () => toJS(AdminStore.sites)
export const getAllSubmissions = () => toJS(AdminStore.submissions)
export const getAllProjects = () => toJS(AdminStore.projects);
export const getProjectById = (project_id) => toJS(AdminStore.project[project_id]);
export const getEmails = () => toJS(AdminStore.emails);
export const getEmailById = (email_id) => toJS(AdminStore.email[email_id]);

export const getAllTeamMembers = () => toJS(AdminStore.teamMembers);

export const getCurrentTimer = () => toJS(AdminStore.clockify_timer);
